import { Platform } from 'react-native';

// Lazily/safely load expo-notifications. On a build that doesn't have this
// native module compiled in yet (e.g. an older installed dev client), the
// require() throws synchronously and we fall back to no-op behavior below.
let Notifications = null;
try {
  Notifications = require('expo-notifications');
  Notifications.setNotificationHandler({
    handleNotification: async () => ({
      shouldShowAlert: true,
      shouldPlaySound: true,
      shouldSetBadge: false,
      shouldShowBanner: true,
      shouldShowList: true,
    }),
  });
} catch {
  Notifications = null;
}

export async function ensureNotificationPermission() {
  if (!Notifications) return false;
  try {
    const settings = await Notifications.getPermissionsAsync();
    if (settings.granted) return true;
    const request = await Notifications.requestPermissionsAsync();
    return request.granted;
  } catch {
    return false;
  }
}

export async function scheduleReminder(title, body, date) {
  if (!Notifications) return null;
  try {
    const granted = await ensureNotificationPermission();
    if (!granted) return null;

    if (Platform.OS === 'android') {
      await Notifications.setNotificationChannelAsync('reminders', {
        name: 'Reminders',
        importance: Notifications.AndroidImportance.HIGH,
      });
    }

    return await Notifications.scheduleNotificationAsync({
      content: { title, body },
      trigger: {
        type: Notifications.SchedulableTriggerInputTypes.DATE,
        date,
        channelId: 'reminders',
      },
    });
  } catch {
    return null;
  }
}

export async function cancelReminder(notificationId) {
  if (!Notifications || !notificationId) return;
  try {
    await Notifications.cancelScheduledNotificationAsync(notificationId);
  } catch {
    // Already fired or cancelled — nothing to do.
  }
}

export async function getPushToken() {
  if (!Notifications || Platform.OS === 'web') return null;
  try {
    const granted = await ensureNotificationPermission();
    if (!granted) return null;
    const token = await Notifications.getExpoPushTokenAsync({
      projectId: 'ddb2d94f-750f-4765-a5c8-5e33d941d406',
    });
    return token.data;
  } catch {
    return null;
  }
}

export async function sendPushNotification(expoPushToken, title, body, data = {}) {
  if (!expoPushToken) return null;
  try {
    const res = await fetch('https://exp.host/--/api/v2/push/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ to: expoPushToken, title, body, data, sound: 'default' }),
    });
    return res.json();
  } catch {
    return null;
  }
}
